// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:28:36Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Rozhraní pro práci s adresami. Generated from cz.marbes.api.adresa.AdresaService.
 */
export default class AdresaApi {
    /**
     * Načtení adresy dle id.
     *
     * @param id id adresy
     * @return adresa
     */
    static getAdresaById(id : number) : Promise<Adresa> {
        const uri = serverContextPath + `/api/adresy/${id}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí stát dle jeho ID
     *
     * @param id ID státu
     * @return stát
     */
    static getStatById(id : number) : Promise<Stat> {
        const uri = serverContextPath + `/api/staty/${id}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Provede ztotožnění adresy vůči registru, pokud je ztotožnění úspěšné, vrátí se ztotožněný objekt s doplněnými informace o zotožnení (id na adresu v registru), jinak se vrátí null.
     *
     * @param adresa vstupní adresa, podle které se má provést ztotožnění
     * @return ztotožněná adresa nebo null, pokud se ztotožnení nepovedlo (např. bylo vráceno více adres apod.)
     */
    static ztotozniAdresu(adresa : Adresa) : Promise<Adresa> {
        const uri = serverContextPath + `/api/adresy/ztotozneni`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateAdresa_CEF31D(adresa), headers));
    }

    /**
     * Vrátí stát České republiky.
     *
     * @return stát České republiky
     */
    static getStatCr() : Promise<Stat> {
        const uri = serverContextPath + `/api/staty/cr`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vytvoření nové adresy.
     *
     * @param adresa objekt adresy
     * @return vytvořená adresa, např. doplněná o id, popis apod.
     */
    static createAdresa(adresa : Adresa) : Promise<Adresa> {
        const uri = serverContextPath + `/api/adresy`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updateAdresa_CEF31D(adresa), headers));
    }

    /**
     * Aktualizace objektu adresy.
     *
     * @param adresaId id adresy pro aktualizaci
     * @param adresa objekt adresy
     * @return aktualizovaná adresa s oplněný dopočítávanými atributy apod.
     */
    static updateAdresa(adresaId : number, adresa : Adresa) : Promise<Adresa> {
        const uri = serverContextPath + `/api/adresy/${adresaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateAdresa_CEF31D(adresa), headers));
    }

    /**
     * Načte státy s možností omezit výsledek pouze na v současnosti existující státy (bez vyplněného platnost do) a na fakticky existující státy, tedy vynechání technických záznamů vedených kvůli uprchlíkům, lidem bez občanství apod.
     *
     * @param pridatTechnicke příznak, zda výsledek obohatit o technické záznamy (bez občanství apod.)
     * @param pridatZanikle příznak, zda výsledek obohatit o zaniklé státy
     * @return seznam států
     */
    static getStaty(pridatTechnicke : boolean, pridatZanikle : boolean) : Promise<Stat[]> {
        const uri = serverContextPath + `/api/staty`;
        const headers = undefined;
        const params = { pridatTechnicke, pridatZanikle };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vezme vstupní adresu a do výstupní nastaví generovaný popis adresy, pouze generuje popis a ten vrací, nijak nemodifikuje uloženou adresu apod.
     *
     * @param adresa vstupní adresa
     * @return výstupní adresa, která datově odpovídá vstupní a má doplněný popis adresy
     */
    static aktualizujPopisAdresy(adresa : Adresa) : Promise<Adresa> {
        const uri = serverContextPath + `/api/adresy/popis`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateAdresa_CEF31D(adresa), headers));
    }

    /**
     * Smaže adresu s daným id.
     *
     */
    static deleteAdresa() {
        const uri = serverContextPath + `/api/adresy/{adresaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Najde adresy podle zadaných id. Pokud pro některá id není adresa nalazena, není ve výstupním seznamu.
     *
     * @param ids seznam id adres
     * @return seznam nalezených adres
     */
    static findAdresyByIds(ids : number[]) : Promise<Adresa[]> {
        const uri = serverContextPath + `/api/adresy/byIds`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, ids, headers));
    }

    /**
     * Fulltextové hledání adres.
     *
     * @param findParams parametrz hledání
     * @return nalezené adresy nebo prázdný seznam
     */
    static findAdresy(findParams : FindAdresyParams) : Promise<Adresa[]> {
        const uri = serverContextPath + `/api/adresy/fulltext`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateFindAdresyParams_6B6AAA(findParams), headers));
    }

    /**
     * Fulltextové hledání adres.
     *
     * @return nalezené subjekty nebo prázdný seznam
     */
    static findObce() : Promise<Obec[]> {
        const uri = serverContextPath + `/api/obce`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}